export default {
  filterData : {
  Products: {
    label: 'Produkter',
    allFilterLabel: "Alle produkter",
    items: [
      { name: "Citrix ADC", id: "citrix_adc" },
      { name: "Citrix Analytics for Performance", id: "citrix_analytics_for_performance" },
      { name: "Citrix Analytics for Security", id: "citrix_analytics_for_security" },     
      { name: "Citrix App Delivery and Security Service", id:"citrix_app_delivery_and_security_service"},
      { name: "Citrix Application Delivery Management", id: "citrix_application_delivery_management" },
      { name: "Citrix Content Collaboration", id: "citrix_content_collaboration" },
      { name: "Citrix DaaS (formerly Citrix Virtual Apps and Desktops service)", id: "citrix_virtual_apps_and_desktops" },
      {
        name: "Citrix DaaS Standard for Azure",
        id: "citrix_virtual_apps_and_desktops_standard_for_azure"
      },
      {
        name: "Citrix DaaS Standard for Google Cloud",
        id: "citrix_daas_standard_for_google_cloud",
      },
      { name: "Citrix Endpoint Management", id: "citrix_endpoint_management" },
      { name: "Citrix Gateway", id: "citrix_gateway" },
      { name: "Citrix SD-WAN", id: "citrix_sd_wan" },
      { name: "Citrix Secure Internet Access", id: "citrix_secure_internet_access" },
      { name: "Citrix Secure Private Access", id: "citrix_secure_private_access" },
      { name: "Citrix Virtual Apps and Desktops", id: "citrix_virtual_apps_desktops" },
      { name: "Citrix Web App and API Protection", id: "citrix_web_app_and_api_protection" },
      { name: "Citrix Workspace", id: "citrix_workspace" },
    ],
  },
  Topics: {
    label: "Emner",
    allFilterLabel: "Alle emner",
    items: [
      { name: "Tilgangsadministrasjon", id: "Access management" },
      { name: "Analyse og overvåkning", id: "Analytics and monitoring" },
      { name: "Applikasjonslevering og sikkerhet", id: "Application delivery and security" },
      { name: "Citrix og Google", id: "Citrix and Google" },
      { name: "Citrix og Microsoft", id: "Citrix and Microsoft" },
      { name: "Skymigrasjon", id: "Cloud migration" },
      { name: "Sammenlign", id: "Compare" },
      { name: "Innholdssamarbeid", id: "Content collaboration" },
      { name: "Digitale arbeidsplasser", id: "Digital workspaces" },
      { name: "Ansattopplevelsen", id: "Employee experience" },
      { name: "Hybrid nettsky", id: "Hybrid cloud" },
      { name: "Hybridarbeid", id: "Hybrid work" },
      { name: "Administrer og optimaliser", id: "Manage and optimize" },
      { name: "Mikrotjenester og devOps", id: "Microservices and devOps" },
      { name: "Igangsettelse og ibruktaking", id: "Onboarding and adoption" },
      { name: "Partnerintegrasjoner", id: "Partner integrations" },
      { name: "Produktoversikt", id: "Product overview" },
      { name: "Sikkerhet og etterlevelse", id: "Security and compliance" },
      { name: "Små og mellomstore virksomheter", id: "Small business" },
      { name: "Spesifikasjoner", id: "Specifications" },
      { name: "Bærekraft", id: "Sustainability" },
      { name: "samlet endepunktsadministrasjon", id: "Unified endpoint management" },
      { name: "VDI og DaaS", id: "VDI and DaaS" },
    ],
  }, 
  Type: {
    label: 'Type',
    allFilterLabel: "Alle typer",
    items: [
      { name: "Analytikerrapport", id: "Analyst report" },
      { name: "Vurderingsverktøy", id: "Assessment tool" },
      { name: "Kundehistorie", id: "Customer story" },
      { name: "Dataark", id: "Data sheet" },
      { name: "Demo", id: "Demo" },
      { name: "E-bok", id: "eBook" },
      { name: "Veiledning", id: "Guide" },
      { name: "Infografikk", id: "Infographic" },
      { name: "Interaktiv omvisning", id: "Interactive tour" },
      { name: "Podkast", id: "Podcast" },
      { name: "Ressurspakke", id: "Resource kit" },
      { name: "Løsningssammendrag", id: "Solution brief" },
      { name: "Teknisk sammendrag", id: "Technical brief" },
      { name: "Video", id: "Video" },
      { name: "Nettseminar", id: "Webinar" },
      { name: "Rapport", id: "White paper" },
    ],
  },
  Industry: {
    label: "Bransje",
    allFilterLabel: "Alle bransjer",
    items: [
      { name: "Utdanning", id: "education" },
      { name: "Finansiell tjeneste", id: "financial_service" },
      { name: "Offentlig sektor", id: "government" },
      { name: "Helsevesenet", id: "healthcare" },
      { name: "Produksjon", id: "manufacturing" },
      { name: "Detaljhandel", id: "retail" }
    ],
  }
  },
  searchPlaceholder: "Søk i bibliotek",
  titles : {
    label1: "Populært nå",
    label2: "Nyeste ressurser",
    label3: "Nylig sett",
    label4: "Anbefalte ressurser"
  },
  showMoreLabel: "Vis mer",
  clearAllSelected: "Fjern alle valgte",
  searchResults: "Søkeresultater for",
  clearAllFilters: "Fjern alle filtre",
  noResultsFound: "Ingen aktiva oppfyller dine valgte kriterier",
  resetView: "Nullstill visning",
  filterLabel: "Filter",
  filteredRes: "Filtrerte resultater",
  filterRes: "Filtrer resultatene dine",
  clearAllCta: "Fjern alle",
  applyCta: "Bruk",
  view: "Vis",
  includeEnglishRes: "Inkluder engelske ressurser"
};
